import React, { useEffect, useRef, useState, useMemo } from "react"
import {useDebounceCallback} from '@react-hook/debounce'
import { useSelector,useDispatch } from "react-redux"
import { envAwarePost, slidingQueryComparision } from "../../util/util"
import { useInView } from 'react-intersection-observer'
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import Popover from "react-bootstrap/Popover"
import Form from "react-bootstrap/Form"
import Card from "react-bootstrap/Card"
import Badge from "react-bootstrap/Badge"
import Select from 'react-select'
import {Link} from 'react-router-dom'
import Modal from "react-bootstrap/Modal"
import Table from "react-bootstrap/Table"
import Alert from "react-bootstrap/Alert"
import useApiStatusEnvAwarePost from "../../hooks/useApiStatusEnvAwarePost"
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch"
import Button from "react-bootstrap/Button"
import Spinner from "react-bootstrap/Spinner"
import classes from "./FoodList.module.css"
import {useFoodLibrary} from './hooks'
import FoodRow from './FoodRow/FoodRow'
import MAXFoodEditor from './MAXFoodEditor'
import { DebounceInput } from "react-debounce-input"
import {searchFoods,getFoods,selectAllFoods} from '../../state/foodLibrary'
import { createFood,updateFood,getPortionUnits,selectLibrary } from '../../state/foodLibrary'
import ListOptions from './ListOptions/ListOptions'
import PortionUnitSelect from '../PortionUnitSelect/PortionUnitSelect'

const FoodList = () => {
  const dispatch = useDispatch()
  const statusDispatch = useApiStatusDispatch()
  const [foodList, setFoodList] = useState([])
  const [listTypes, setListTypes] = useState(
    Boolean(localStorage.getItem('listTypes'))
    ? JSON.parse(localStorage.getItem('listTypes'))
    : ["all_foods"]
  )
  const [addEditLoding, setAddEditLoading] = useState(false)
  const [searchQuery,setSearchQuery] = useState("")
  const [isDeleting, setIsDeleting] = useState(false)

  const [showFoodCategoriesModal,setShowFoodCategoriesModal] = useState(false)

  const user = useSelector( state => state.users.current_user )
  const {tgtUser:currentTgtUser} = useSelector(selectLibrary)
  const foods = useSelector(selectAllFoods)

  const [status,setStatus] = useState('idle')
  const statusEnvPost = useApiStatusEnvAwarePost()
  const owners =  Array.from(
    new Set(foods.map(f=>f.owner_type))
  ).sort(
    (a,b)=>a<b?-1:1
  )

  const isClient = user.account_type === 'client'
  const isChain = user.account_type === 'chain'
  const isMAXCorporate = isChain && user.isMAXUser === 1

  const foodBlockSize = 100
  const [displayCount,setDisplayCount] = useState(foodBlockSize)
  const [ownerFilter,setOwnerFilter] = useState('all')
  const isOwner = (
    (user.account_type === 'gym') ||
    (user.gym_id == 0 && user.account_type === 'trainer')
  )

  const matchesFilters = f => {
    const ownerMatch = (
      ownerFilter === 'all' ||
      f.owner_type === ownerFilter ||
      //MAX has a custom food list that all users should see 
      user.isMAXUser
    )

    return (
      ownerMatch
    )
  }

  const { ref:scrollRef, inView } = useInView({
    /* Optional options */
    threshold: 0,
  })

  const pendingRequestRef = useRef()

  useEffect(()=>{
    if (listTypes.length === 0) return
    if (pendingRequestRef.current&&pendingRequestRef.current.abort) {
      pendingRequestRef.current.abort()
    }
    if (!searchQuery) return 

    setStatus('pending')
    const promise = dispatch(
        searchFoods({
          list_types:listTypes,
          query:searchQuery,
          limit:foodBlockSize,
          offset:0,
          clearFoods:true
        })
      ).finally(()=>{
        setStatus('idle')
      })
    pendingRequestRef.current = promise
  },[listTypes])

  /*
  useEffect(()=>{
    if (listTypes.length === 0) return
    if (pendingRequestRef.current&&pendingRequestRef.current.abort) {
      pendingRequestRef.current.abort()
    }
    let promise
    //if a query is set the search the new list type using the query
    if (Boolean(searchQuery)) {
      promise = dispatch(
        searchFoods({
          list_types:listTypes,
          query:searchQuery,
          limit:foodBlockSize,
          offset:0,
          clearFoods:true
        })
      )
    }
    //else default to a fetch
    else { 
      promise = dispatch(
        getFoods({
          list_types:listTypes,
          limit:foodBlockSize,
          offset:0,
          clearFoods:true
        })
      )
    }
    pendingRequestRef.current = promise
  },[searchQuery])

  useEffect(()=>{
    if(!inView||isLoadingList) return 
    if (pendingRequestRef.current&&pendingRequestRef.current.abort) {
      pendingRequestRef.current.abort()
    }
    let promise
    //if a query is set the search the new list type using the query
    if (Boolean(searchQuery)) {
      promise = dispatch(
        searchFoods({
          list_types:listTypes,
          query:searchQuery,
          limit:foodBlockSize,
          offset:foods.length,
          append:true
        })
      )
    }
    //else default to a fetch
    else { 
      promise = dispatch(
        getFoods({
          list_types:listTypes,
          limit:foodBlockSize,
          offset:foods.length,
          append:true
        })
      )
    }
    pendingRequestRef.current = promise
  },[inView])*/

  const [showMAXFoodEditor,setShowMAXFoodEditor] = useState(false)

  //Food Modal
  const [showFoodModal, setShowFoodModal] = useState(false)
  const handleFoodModalClose = () => {
    cleanModalData()
    setShowFoodModal(false)
  }
  const handleFoodModalOpen = () => setShowFoodModal(true)

  //Message alert
  const [showAlert, setShowAlert] = useState(false)
  const [alertMsg, setAlertMsg] = useState("")

  // variables for requests to add / edit foods
  const [itemName, setItemName] = useState("")
  const [itemId, setItemId] = useState(0)
  const [calories, setCalories] = useState("")
  const [protein, setProtein] = useState("")
  const [carbs, setCarbs] = useState("")
  const [fat, setFat] = useState("")
  const [sodium, setSodium] = useState("")
  const [fiber, setFiber] = useState("")
  const [link, setLink] = useState("")
  const [portionUnit,setPortionUnit] = useState(0)
  const [portionSize,setPortionSize] = useState(0)
  const [portionDescription,setPortionDescription] = useState("")
  const [defaultItem, setDefaultItem] = useState(0)
  const [isEditing, setIsEditing] = useState(false)

  function fillEditData(food) {
    setIsEditing(true)
    setItemName(food.food_db_name)
    setItemId(food.food_db_id)
    setCalories(food.calories)
    setProtein(food.protein)
    setCarbs(food.carbs)
    setFat(food.fat)
    setSodium(food.sodium)
    setFiber(food.fiber)
    setLink(food.link)
    setDefaultItem(food.defaultItem)
    setPortionUnit(food.portion_unit_id)
    setPortionSize(food.portion_size)
    setPortionDescription(food.portion_description)
  }

  function cleanModalData() {
    console.log("Cleaning Modal Data....")
    setIsEditing(false)
    setItemName("")
    setItemId(0)
    setCalories("")
    setProtein("")
    setCarbs("")
    setFat("")
    setFiber("")
    setSodium("")
    setLink("")
    setDefaultItem(0)
    setPortionUnit(0)
    setPortionSize(0)
    setPortionDescription("")
  }

  function addOrEdit() {
    if (itemName == "") {
      alert("You must specify a food name.")
      return
    }
    if (!isEditing) {
      const payload = {
        food_db_name:itemName,
        portion_unit_id:portionUnit,
        portion_size:portionSize,
        portion_description:portionDescription,
        calories,
        protein,
        sodium,
        fiber,
        carbs,
        link,
        fat
      }
      setAddEditLoading(true)
      statusDispatch(createFood(payload),'food','create').then(()=>{
        setAddEditLoading(false)
        handleFoodModalClose()
      })

    }else{
      const payload = {
        id:itemId,
        update:{
          user_id_number: user.user_id_number,
          food_db_id: itemId,
          portion_unit_id:portionUnit,
          portion_size:portionSize,
          portion_description:portionDescription,
          food_db_name:itemName,
          calories,
          protein,
          sodium,
          fiber,
          carbs,
          link,
          fat
        }
      }
      setAddEditLoading(true)
      statusDispatch(updateFood(payload),'food','edit').then((res)=>{
        console.log(res)
        setAddEditLoading(false)
        handleFoodModalClose()
      })    
    }
  }

  const foodRef = useRef()
  function deleteFood(user_id_number, item_db_id, defaultItem) {
    const reqObj = {
      selector: "food",
      user_id_number: user_id_number,
      item_db_id: item_db_id,
      defaultItem: defaultItem,
      operation: "delete",
    }
    let confirmDel = window.confirm(
      "Are you sure you want to delete this food and all the data associated with it?"
    )
    if (confirmDel) {
      setIsDeleting(true)
      statusEnvPost("exerFoodListAddEditDeleteMobWeb.php", reqObj, "food","delete")
        .then((res) => {
          console.log(reqObj.item_db_id)
          setFoodList(
            foods.filter((food) => food.food_db_id != reqObj.item_db_id)
          )
          setIsDeleting(false)
          foodRef.current.textContent = "X"
        })
        .catch((err) => console.log(err))
    }
  }

  const dispatchSearch = query => {
    if (!query) return 
    setStatus('pending')
    if (pendingRequestRef.current&&pendingRequestRef.current.abort) {
      pendingRequestRef.current.abort()
    }
    const promise = dispatch(searchFoods({query,list_types:listTypes,clearFoods:true}))
      .finally(()=>{
        setStatus('idle')
      })
    pendingRequestRef.current = promise
  }

  const handleClearSearch = ()=>{
    setSearchQuery('')
    if (pendingRequestRef.current&&pendingRequestRef.current.abort) {
      pendingRequestRef.current.abort()
    }
    pendingRequestRef.current = dispatch(
      getFoods({
        list_types:listTypes,
        limit:foodBlockSize,
        offset:0,
        clearFoods:true
      })
    )
  }

  const debouncedSearch = useDebounceCallback(dispatchSearch,400)

  const handleSearch = query => {
    setSearchQuery(query)
    if(!query){
      if (pendingRequestRef.current&&pendingRequestRef.current.abort) {
        pendingRequestRef.current.abort()
      }
      setStatus('idle')
      return
    }
    setStatus('typing')
    debouncedSearch(query)
  }

  const [showFilterPopover,setShowFilterPopover] = useState(false)

  return (
    // <div className={classes.MainBody}>
    <div className="py-2 px-2 px-md-3" id="containerDiv">
      <strong>Food List</strong>
      {showAlert && (
        <Alert className="alert-success" dismissible onClose={() => setShowAlert(false)}>
          <p className="text-dark">{alertMsg}</p>
        </Alert>
      )}
      <div className="bg-white p-2 rounded">
        <div className="d-flex mb-2">
          <div className={classes.SearchInputBlock}>
            <Form.Control
              value={searchQuery}
              className="form-control"
              placeholder="Search for a food name in the list below"
              onChange={e=>{
                handleSearch(e.target.value)
              }}
            />
            <div className={classes.ClearSearchBtn} onClick={handleClearSearch}>x</div>
          </div>
          {(!user?.isMAXUser && (user.user_trainer_id != user.gym_id)) && (
            <Button
              style={{flex:'0 0 auto'}}
              size="sm"
              variant="outline-success"
              onClick={handleFoodModalOpen}
              className="ml-1"
            >
              Add Food
            </Button>
          )}
        </div>
        {(!user.isMAXUser)&&
          <div className="d-md-none">
            <OverlayTrigger 
              show={showFilterPopover}
              onHide={setShowFilterPopover.bind(null,false)}
              trigger="click" 
              placement="bottom" 
              overlay={
                <Popover onClick={e=>{e.stopPropagation()}}>
                  <Popover.Content>
                    <ListOptions 
                      accountType={user.account_type}
                      selected={listTypes}
                      onChange={selected=>{
                        if(selected.length===0)return
                        setListTypes(selected)
                      }}
                    />
                  </Popover.Content>
                </Popover>
              }
            >
              <Button 
                onClick={()=>{
                  setShowFilterPopover(p=>!p)
                }}
                variant={
                  showFilterPopover
                  ? 'outline-danger'
                  : "outline-primary"
                } 
                size="sm"
              >
                <i className={showFilterPopover?'fas fa-times':"fas fa-filter"}/> Filters
              </Button>
            </OverlayTrigger>
          </div>
        }
        <div className="d-none d-md-flex">
          {(!user.isMAXUser)&&
            <ListOptions 
              accountType={user.account_type}
              selected={listTypes}
              onChange={selected=>{
                setListTypes(selected)
              }}
            />
          }
        </div>
        {!user.isMAXUser&&
        <a href="https://www.fatsecret.com">
          <img src="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret.png" srcset="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_2x.png 2x, https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_3x.png 3x" border="0"/>
        </a>
        }
        {(user.isMAXUser === 1 && isClient) &&
          <div className="mb-2">
            <i className="fa fa-info-circle mr-2" /> Tip: you can add foods to your current day's nutrition
            totals by clicking the "Add to Nutrition" button (eg. adding an Apple will add 1 fruit to your current fruit total)
          </div>
        }
      </div>
      <Table bordered hover className={classes.foodTable}>
        <thead>
          <tr>
            <th style={{ width: "95%" }}>Food</th>
            {!user?.isMAXUser && (user.gym_id!=0?user.account_type === 'gym':user.account_type==='trainer') && ownerFilter === user.account_type && (
              <th>
                <Button
                  variant="outline-danger"
                  className={classes.DeleteAllBtn}
                  onClick={() =>
                    deleteFood(user.user_id_number, "deleteAll")
                  }
                >
                  <i
                    class="fa fa-trash"
                    aria-hidden="true"
                    style={{ paddingRight: 10 }}
                  ></i>
                  All
                </Button>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {(status==='idle'&&foods.length===0&&searchQuery!=='')&&
            <div className="p-2">
              No results...
            </div>
          }

          {status==='typing'&&
            <div className="p-2">
              Typing...
            </div>
          }

          {(status==='idle'&&searchQuery==='')&&
            <div className="p-2">
              Use the search above to find foods...
            </div>
          }

          {(foods.length > 0&&status==='idle'&&searchQuery!=='') &&
            foods
              .map((food) => (
                <FoodRow
                  key={food.food_db_id}
                  ownerFilter={ownerFilter}
                  foodRef={foodRef}
                  isDeleting={isDeleting}
                  handleFoodModalOpen={handleFoodModalOpen}
                  fillEditData={fillEditData}
                  food={food}/>
              ))
          }
        </tbody>
      </Table>
      <div ref={scrollRef}/>
      <Modal show={showFoodModal} onHide={handleFoodModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? "Edit" : "Add"} Food</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.InputBlock}>
            <span>Food Name:</span>
            <DebounceInput
              minLength={1}
              debounceTimeout={300}
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
              className={["form-control", classes.InputBox].join(" ")}
            />
          </div>
          <div className={classes.InputBlock}>
            <span>Portion Unit (e.g. scoop):</span>
            <PortionUnitSelect
              portionUnit={portionUnit}
              onChange={selected=>{
                setPortionUnit(selected.value)
              }}
            />
          </div>
          <div className={classes.InputBlock}>
            <span>Portion Size:</span>
            <Form.Control 
              value={portionSize}
              className="w-50"
              onChange={e=>{
                setPortionSize(e.target.value)
              }}
            />
          </div>
          <div className={classes.InputBlock}>
            <span>Portion Description:</span>
            <Form.Control 
              value={portionDescription}
              onChange={e=>{
                setPortionDescription(e.target.value)
              }}
              placeholder="Example: large slice"
              className="w-50"
              as="textarea"
            />
          </div>
          <div className={classes.InputBlock}>
            <span>Calories:</span>
            <DebounceInput
              type="number"
              minLength={1}
              debounceTimeout={300}
              value={calories}
              onChange={(e) => setCalories(e.target.value)}
              className={["form-control", classes.InputBox].join(" ")}
            />
          </div>
          <div className={classes.InputBlock}>
            <span>Proteins:</span>
            <DebounceInput
              type="number"
              minLength={1}
              debounceTimeout={300}
              value={protein}
              onChange={(e) => setProtein(e.target.value)}
              className={["form-control", classes.InputBox].join(" ")}
            />
          </div>
          <div className={classes.InputBlock}>
            <span>Carbs:</span>
            <DebounceInput
              type="number"
              minLength={1}
              debounceTimeout={300}
              value={carbs}
              onChange={(e) => setCarbs(e.target.value)}
              className={["form-control", classes.InputBox].join(" ")}
            />
          </div>
          <div className={classes.InputBlock}>
            <span>Fat:</span>
            <DebounceInput
              type="number"
              minLength={1}
              debounceTimeout={300}
              value={fat}
              onChange={(e) => setFat(e.target.value)}
              className={["form-control", classes.InputBox].join(" ")}
            />
          </div>
          <div className={classes.InputBlock}>
            <span>Sodium:</span>
            <DebounceInput
              type="number"
              minLength={1}
              debounceTimeout={300}
              value={sodium}
              onChange={(e) => setSodium(e.target.value)}
              className={["form-control", classes.InputBox].join(" ")}
            />
          </div>
          <div className={classes.InputBlock}>
            <span>Fiber:</span>
            <DebounceInput
              type="number"
              minLength={1}
              debounceTimeout={300}
              value={fiber}
              onChange={(e) => setFiber(e.target.value)}
              className={["form-control", classes.InputBox].join(" ")}
            />
          </div>
          <div className={classes.InputBlock}>
            <span>Info Link (Optional):</span>
            <DebounceInput
              minLength={1}
              debounceTimeout={300}
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder={
                "Example: https://www.chipotle.com/nutrition-calculator?format=aspx"
              }
              className={["form-control", classes.InputBox].join(" ")}
            />
          </div>
          {addEditLoding && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            onClick={() => {
              addOrEdit()
              //handleFoodModalClose()
            }}
            disabled={addEditLoding}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      {status==='pending'&&
        <div className="d-flex align-items-center justify-content-center p-4">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      }
    </div>
  )
}

export default FoodList
